<template>
  <el-dialog :visible.sync="dialogValue" title="从公共字体添加"
             custom-class="sys-font-dialog"
             class="global-dialog"
             width="950px"
             @closed="onClosed"
             :append-to-body="true"
             :close-on-click-modal="false">
    <div>
     <sys-font ref="sys-font" :selector="true" :systemFont="true" @onChange="onChange" :projectId="projectId"></sys-font>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="onSave(false)" :loading="loading" :disabled="ids.length === 0">配置到所选项目组</el-button>
    </div>
    <el-dialog
      title="字体上传"
      class="global-dialog font-uploader-dialog"
      width="550px"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
        <div v-show="uploadStatus === 'success'" class="font-uploader-box-wrap">
            <span>字体已成功上传！</span><br>
            {{ uploadFontName || '' }}
        </div>
        <div v-show="uploadStatus === 'exist'" class="font-uploader-box-wrap">
            <span>该字体已存在，上传后将替换原字体文件，是否继续上传？</span><br>
            {{ uploadFontName || '' }}
        </div>
        <div v-show="uploadStatus === 'error'" class="font-uploader-box-wrap">
            <span>字体上传失败，请重新上传</span>
        </div>
        <div slot="footer">
            <el-button :type="uploadStatus === 'success' || uploadStatus === 'error' ? 'primary' : ''" @click="dialogVisible = false">
            {{ uploadStatus === 'success'  || uploadStatus === 'error' ? '关闭' : '取消' }}
            </el-button>
            <el-button v-show="uploadStatus === 'exist'" type="primary" @click="onSave(true)">继续上传</el-button>
        </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
    import fontService from '@/request/service/font-service'
    import sysFont from './font-system-index'
    export default {
        components: {sysFont},
        props: {
            value: {type: Boolean, default: false},
            projectId: {type: String}
        },
        data() {
            return {
                dialogVisible: false,
                uploadStatus: '',
                uploadFontName: '',
                ids: [],
                loading: false
            }
        },
        computed: {
            dialogValue: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                }
            },
        },
        watch: {
            dialogVisible (val) {
                !val && (this.loading = false)
                if (!val && this.uploadStatus === 'success') {
                    this.$emit('onChange', this.ids);
                }
            }
        },
        methods: {
            onChange(dataList){
                this.ids = dataList;
            },
            onClosed(){
                this.loading = false;
            },
            onSave(overwrite = false) {
                if(this.ids.length === 0){
                    return;
                }
                this.loading = true;
                fontService.setProjectFont(this.ids, this.projectId, overwrite).then((d) => {
                    if (d === 'SUCCESS') {
                        this.uploadStatus = 'success'
                        this.uploadFontName = `共${this.ids.length}个字体`
                        this.dialogVisible = true
                        this.dialogValue = false
                        this.$refs['sys-font'].getData()
                        // this.$emit('onChange', this.ids);
                    } else {
                        this.uploadStatus = 'exist'
                        this.uploadFontName = d
                        this.dialogVisible = true
                    }
                    // this.$message.success('字体添加成功')
                    // this.formVisible = false
                    // this.$emit('onChange', this.ids);
                }).catch(() => {
                    this.uploadStatus = 'error'
                    this.dialogVisible = true
                }).finally(() => {
                    this.loading = false;
                })
            },
        }
    }
</script>
<style>
@import '~@/views/template/font/font-uploader-box/index.scss';
</style>